import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import Nav from '../components/Nav';
import Footer from '../components/Footer';
import Form from '../components/FormBlock';
import axios from 'axios';

const BlogPage = () => {
  const location = useLocation();
  const { id } = useParams();
  const [blog, setBlog] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  useEffect(() => {
    const fetchBlog = async () => {
      try {
        const serverBaseUrl = process.env.REACT_APP_SERVER_BASE_URL || 'http://localhost:5000';
        const res = await axios.get(`${serverBaseUrl}/api/blogs/${id}`);
        setBlog(res.data);
      } catch (error) {
        console.error('Помилка завантаження блогу:', error);
      }
    };
    fetchBlog();
  }, [id]);

  if (!blog) return <div>Loading...</div>;

  return (
    <div className="content_container">
      <Nav />
      <div className="container">
        <div className="blog_page-container">
          <h1 className="blog_page-title">{blog.title}</h1>
          <img className="blog_page-image" src={blog.imageUrl} alt={blog.title} />
          {blog.contentBlocks.map((block, index) => (
            <p key={index} className="descr_page-blog">{block}</p>
          ))}
        </div>
        <Form />
        <Footer />
      </div>
    </div>
  );
};

export default BlogPage;